function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7567 2.06681C12.7567 0.939457 11.8187 0 10.6931 0H2.06358C0.93799 0 0 0.939457 0 2.06681V13.7161C0 14.8434 0.93799 15.7829 2.06358 15.7829H7.61648L7.76656 14.8434C7.8416 14.4301 8.02919 14.0543 8.32935 13.7536L12.7567 9.31941V2.06681ZM3.00157 3.00626H6.00313C6.41585 3.00626 6.75353 3.34447 6.75353 3.75783C6.75353 4.17119 6.41585 4.50939 6.00313 4.50939H3.00157C2.58885 4.50939 2.25118 4.17119 2.25118 3.75783C2.25118 3.34447 2.58885 3.00626 3.00157 3.00626ZM6.75353 10.5219H3.00157C2.58885 10.5219 2.25118 10.1837 2.25118 9.77035C2.25118 9.35699 2.58885 9.01879 3.00157 9.01879H6.75353C7.16624 9.01879 7.50392 9.35699 7.50392 9.77035C7.50392 10.1837 7.16624 10.5219 6.75353 10.5219ZM9.75509 7.51566H3.00157C2.58885 7.51566 2.25118 7.17745 2.25118 6.76409C2.25118 6.35073 2.58885 6.01252 3.00157 6.01252H9.75509C10.1678 6.01252 10.5055 6.35073 10.5055 6.76409C10.5055 7.17745 10.1678 7.51566 9.75509 7.51566Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6341 10.0309L16.6961 9.09144C16.3209 8.71566 15.6455 8.52777 14.9702 9.24175L9.41728 14.8033C9.34224 14.8785 9.2672 14.9912 9.2672 15.104L8.85449 17.3587C8.81697 17.5466 8.89201 17.7344 9.00456 17.8472C9.11712 17.9599 9.2672 17.9975 9.41728 17.9975C9.4548 17.9975 9.49232 17.9975 9.52984 17.9975L11.781 17.5841C11.8936 17.5466 12.0061 17.509 12.0812 17.4338L17.6341 11.8722C18.1218 11.3837 18.1218 10.557 17.6341 10.0309Z"
});

function SvgIconIsDropLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsDropLead);
export default __webpack_public_path__ + "static/media/icon_isDropLead.bc28ff5b.svg";
export { ForwardRef as ReactComponent };